import { Injectable } from '@angular/core';
import { CompanyName, ProvisioningService, PublicApi } from '@shared/constants/constants';
import { IActivityLog as IEvnInvActivityLog } from '../api/dashboard/invitations-service/invitations-model';
import { IAttendeeActivityLog as ITenantAttActivityLog } from '../api/dashboard/activitylogs-service/activitylogs-model';
import { ActivityType, Application, IActivityLogBase } from './activity.models';

@Injectable()
export class ActivityService {

  public static isConfirmedInvitationAndContactUpdated(activity: IActivityLogBase) {
    if (activity.type === ActivityType.InvitationConfirmedContactActivity ||
      activity.type === ActivityType.InvitationConfirmedActivity ||
      activity.type === ActivityType.InvitationConfirmedFrontDeskActivity ) {
      const evActivity = activity as IEvnInvActivityLog;
      if (evActivity.isUpdate) {
        return true;
      }
    }
    return false;
  }

  public static isConfirmedInvitation(activity: IActivityLogBase) {
    return activity.type === ActivityType.InvitationConfirmedContactActivity ||
      activity.type === ActivityType.InvitationConfirmedActivity ||
      activity.type === ActivityType.InvitationConfirmedFrontDeskActivity;
  }

  public static isCrmActivity(activity: IActivityLogBase) {
    return activity.type?.includes('ConnectorActivity') && activity.crm;
  }
  public static isAadActivity(activity: IActivityLogBase) {
    return activity.type?.endsWith('AadActivity');
  }
  public static hasContextAddressBook(displayable: any) {
    return displayable?.context?.includes('addressbook');
  }
  public static hasContextInvitation(displayable: any) {
    return displayable.context?.includes('invitation');
  }

  public static isOfRoleType(activity: IActivityLogBase): boolean {
    return activity.type?.startsWith('Role');
  }

  public static isOfUserRoleType(activity: IActivityLogBase): boolean {
    return activity.type?.startsWith('UserRole');
  }

  static isOfUserType(activity: IActivityLogBase): boolean {
    return activity.type?.startsWith('User');
  }

  public static isConfirmedInvitationAndContactCreated(activity: IActivityLogBase) {
    if (activity.type === ActivityType.InvitationConfirmedContactActivity
      || activity.type === ActivityType.InvitationConfirmedFrontDeskActivity) {
      const evActivity = activity as IEvnInvActivityLog;
      if (evActivity?.isContactCreated) {
        return true;
      }
      const tenAttActivity = activity as ITenantAttActivityLog;
      if (tenAttActivity?.isContactCreated) {
        return true;
      }
    }
    return false;
  }

  public static isOfBatchType(activity: IActivityLogBase): boolean {
    return activity.batchCount > 0;
  }

  public static isOfMailType(activity: IActivityLogBase): boolean {
    // includes Send(Mail|AhHocMail)Activity
    return activity.type?.toLowerCase()?.includes('mail');
  }

  public static isOfImportType(activity: IActivityLogBase): boolean {
    return activity.type?.toLowerCase()?.includes('import');
  }

  public static isOfExportType(activity: IActivityLogBase): boolean {
    return activity.type?.toLowerCase()?.includes('export');
  }

  public static isOfReportType(activity: IActivityLogBase) {
    return activity.type?.toLowerCase()?.startsWith('report');
  }

  public static isOfDocumentType(activity: IActivityLogBase): boolean {
    return activity.type?.toLowerCase()?.includes('document');
  }

  public static isOfCustomFieldTemplateType(activity: IActivityLogBase): boolean {
    return activity.type?.toLowerCase()?.includes('customfieldtemplate');
  }

  public static isOfInvitationType(activity: IActivityLogBase): boolean {
    return activity.type?.toLowerCase()?.includes('invitation');
  }

  public static getActorName(activityLog: IActivityLogBase): string {
    if (activityLog.type?.includes('ContactActivity')) {
      if (activityLog.contactName !== '') {
        return activityLog.contactName;
      }
      // older versions of activitylog do not support contactName
      return activityLog.contactEmail;
    }
    if (activityLog.application === Application.PublicApi) {
      return PublicApi;
    }
    if (ActivityService.isAadActivity(activityLog)) {
      return ProvisioningService;
    }
    if (activityLog.type?.includes('ConnectorActivity')) {
      return activityLog.crm;
    }
    if (activityLog.type?.includes('SchedulerActivity')) {
      return CompanyName;
    }
    if (activityLog.userName !== '') {
      return activityLog.userName;
    }
    // older versions of activitylog do not support userName
    return activityLog.userEmail;
  }

}
